var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2d2d2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.45,504H23.64c-12,0-15.76-3.84-15.64-16C9,385.5,81.52,296.15,182.56,273.45c11.93-2.68,24.25-4.74,36.44-5,38.54-.84,77.19-3.37,115.32,5.83,84.76,20.43,152.21,92.41,166.25,178.39a329.23,329.23,0,0,1,3.38,35.5c.6,11-4.54,15.83-15.54,15.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.05,126.12A118,118,0,1,1,256.67,8C321.56,8.15,374.1,61,374.05,126.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserIcon);
export default __webpack_public_path__ + "static/media/default_user_icon.9072a8fd9793985c8bf69c2fa1ab74d8.svg";
export { ForwardRef as ReactComponent };